import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { PermissionService } from '../_services/permission.service';
import { environment } from '../../environments/environment';
import { ILocalStorageUser, User } from '../_models/user';
import { CookieService } from 'ngx-cookie-service';
import { HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { CustomerModel } from 'app/_models/customer';

@Injectable()
export class AuthenticationService {


    private currentUser: ILocalStorageUser = null;
    public token: string;
    public data: any;
    public static COOKIE_TOKEN_NAME: string = 'access-token';
    public static COOKIE_JWT_TOKEN_NAME: string = 'jwt-token';

    constructor(private permissions: PermissionService,
        private cookieService: CookieService,
        private router: Router,
        private http: Http) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        // this.token = this.currentUser && this.currentUser.token;
    }

    public getAuthCookie() {
        const access_token = this.cookieService.get(AuthenticationService.COOKIE_TOKEN_NAME);
        const actual_token = environment.developmentAccessToken ? environment.developmentAccessToken : access_token
        return actual_token;
    }
    public getAuthJwtCookie() {
        return this.cookieService.get(AuthenticationService.COOKIE_JWT_TOKEN_NAME);
    }

    private redirectUserToSSOLogin() {
        console.log('No Cookie redirecting or expired');
        this.resetUser();
        location.href = environment.ssoAuthUrl + 'login/';
    }

    public async ssoLogin() {
        debugger
        const accessToken = this.getAuthCookie();
        if (!accessToken && !environment.production) {
            this.redirectUserToSSOLogin();
            return false;
        }

        console.log('Logged in SSO', accessToken);

        const token = accessToken;
        this.cookieService.set(AuthenticationService.COOKIE_TOKEN_NAME, token);


        // Store the user details to local storage
        // TODO - get user details from datalove user getcurrentuser api
        // const response: any = await fetch(environment.apiHost + '/api/user/get_current_user/',{
        //     headers: {Authorization: 'Bearer ' + accessToken}
        // });

        const details = await this.getUser(accessToken);
        console.log('user after await')
        if (details && details.user) {
            console.log('In user after await');

            const lastLoggedInUserId: number = JSON.parse(localStorage.getItem('dlLastLoggedInUserId'));
            if (lastLoggedInUserId !== details.user.id) {
                localStorage.clear();
            }
            this.permissions.setPermissionsAndRoles(details.user);
            localStorage.setItem('dlLastLoggedInUserId', JSON.stringify(details.user.id));
            localStorage.setItem('currentUser', JSON.stringify(details));
            localStorage.setItem('userPerm', JSON.stringify(
                { perms: details.user.permission, prefs: details.user.prefs, modules: details.user.modules }));
            return true;
        } else {
            this.redirectUserToSSOLogin();
            return false;
        }



    }

    async getUser(accessToken) {
        try {
            let res = await fetch(environment.apiHost + '/api/user/get_current_user/', {
                headers: { Authorization: 'Bearer ' + accessToken }
            });
            if (res.status === 200) {
                const user = {
                    user: await res.json()
                }
                return user;
            } else {
                return null
            }
        } catch (error) {
            console.log(error);
            throw new Error('Network response was not OK');
        }
    }

    //* API to return a JWT from a Bearer token */
    public async fetchJwtTokenFromBearer() {
        // return this.http.get(`/api/reobtain_jwt/`);
        try {
            const bearerToken = this.getAuthCookie();
            let res = await fetch(environment.apiHost + `/api/reobtain_jwt/`, {
                headers: { Authorization: 'Bearer ' + bearerToken }
            });
            if (res.status === 200) {
                const user = await res.json();
                return await user
            } else {
                return null
            }
        } catch (error) {
            console.log(error);
            throw new Error('Network response was not OK');
        }
    }
    public async getJwtTokenFromBearer() {
        return this.http.get(`/api/reobtain_jwt/`);
    }





    private resetUser() {
        this.token = null;
        this.cookieService.delete(AuthenticationService.COOKIE_TOKEN_NAME);
        this.permissions.flushPermissions();
        this.permissions.flushRoles();

        localStorage.removeItem('currentUser');
        localStorage.removeItem('currentUserDetails');
        localStorage.removeItem('userPerm');
    }

    async logout() {
        this.resetUser();
        setTimeout(() => {
            // TODO call the logout SSO API
            const nonRestrictedRoutes = ["/help", "/qr", "/help/report_accident"];
            const routerUrl = this.router.url.split('?')[0];
            if (!nonRestrictedRoutes.includes(routerUrl)) {
                location.href = environment.ssoAuthUrl + 'logout/?redirect_uri=/login';
            }
        }, 500);

    }

    // Legacy (Pre SSO) Login
    login(email: string, password: string): Observable<boolean> {
        return this.http.post(environment.apiHost + '/api/authenticate', JSON.stringify({
            username: email,
            email: email,
            password: password
        }), {
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        })
            .map((response: Response) => {
                const _res: ILocalStorageUser = response.json();
                const token = _res && _res.token;
                if (token) {
                    this.token = token;
                    const lastLoggedInUserId: number = JSON.parse(localStorage.getItem('dlLastLoggedInUserId'));
                    if (lastLoggedInUserId !== _res.user.id) {
                        localStorage.clear();
                    }
                    localStorage.setItem('dlLastLoggedInUserId', JSON.stringify(_res.user.id));
                    localStorage.setItem('currentUser', JSON.stringify(_res));
                    // TODO - remove this lecacy object as all data  is in the 'currentUser' as it is returned from server
                    localStorage.setItem('userPerm', JSON.stringify(
                        { perms: _res.user.permission, prefs: _res.user.prefs, modules: _res.user.modules }));
                    return true;
                } else {
                    return false;
                }
            });
    }

    GetCurrentCustomer() {
        return new Promise<CustomerModel>((resolve, reject) => {
            const bearerToken = this.getAuthCookie();
            let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', Authorization: 'Bearer ' + bearerToken});
            this.http.get(environment.apiHost + '/api/fmt/user/get_current_user_with_image/', { headers: headers })
                .subscribe((res: any) => {
                    resolve(JSON.parse(res._body));
                }, (err) => {
                    reject(err);
                });
        });
    }

}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/authentication.service.ts